exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-grid-wrapper[data-v-6b18a6c2]{width:100%;padding-bottom:10px}.embed-grid-wrapper>div[data-v-6b18a6c2]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
